'use client';

import React, { useState } from 'react';
import { Chip, Modal, Box, Typography, IconButton, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DiscoBall from '../../components/disco_ball';

const ExclusiveChip: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleChipClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Chip
                label="EXCLUSIVE PRICING"
                icon={<InfoIcon sx={{ color: 'white' }} />}
                onClick={handleChipClick}
                sx={{
                    backgroundColor: '#C0C0DD',
                    color: '#1C1C34',
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    padding: '4px 8px',
                    borderRadius: '16px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: '#D8A8E8',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                    },
                }}
            />
            <Modal
                open={isModalOpen}
                onClose={handleCloseModal}
                aria-labelledby="exclusive-modal-title"
                aria-describedby="exclusive-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '95%',
                    maxWidth: 400,
                    bgcolor: '#1C1C34',
                    color: 'white',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 3,
                    maxHeight: '90vh',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Typography
                            id="exclusive-modal-title"
                            variant="h5"
                            component="h2"
                            gutterBottom
                            fontFamily='Roboto Condensed'
                            marginTop={2}
                            sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                        >
                            Exclusive Deals with
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ position: 'relative', width: '60px', height: '60px' }}>
                                <DiscoBall />
                            </Box>
                            <Typography
                                fontFamily='Inter'
                                fontSize='1.25rem'
                                color='white'
                                sx={{
                                    fontWeight: 'bold',
                                    position: 'relative',
                                    left: '-30px',
                                    zIndex: 2,
                                    textShadow: '2px 2px 8px rgba(0, 0, 0, 0.6)',
                                    userSelect: 'none',
                                    WebkitUserSelect: 'none',
                                    MozUserSelect: 'none',
                                    msUserSelect: 'none'
                                }}
                            >
                                litty
                            </Typography>
                        </Box>
                    </Box>
                    <Typography id="exclusive-modal-description" sx={{ fontFamily: 'Inter', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                        We've worked out exclusive deals for you when you book through us. Enjoy special perks and discounts available only on Litty!
                    </Typography>
                    <Typography sx={{ mt: 2, fontFamily: 'Inter', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                        Questions? <a href="/contact" style={{ color: '#C0C0DD' }}>Contact us</a>
                    </Typography>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            onClick={handleCloseModal}
                            sx={{
                                color: 'white',
                                borderColor: 'white',
                                '&:hover': {
                                    borderColor: 'white',
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                },
                                fontSize: { xs: '0.8rem', sm: '0.9rem' }
                            }}
                            variant="outlined"
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default ExclusiveChip;
